import Button from 'Elements/Button';
import Select from 'Elements/Input/Select';
import styled, { css } from 'styled-components';

export const Listing = styled.ul`
    ${({ theme }) => css`
        list-style-type: none;
        padding: 0;
        margin-bottom: 1.5rem;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 1.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 0.75rem;
            margin-bottom: 3rem;
            column-gap: 1.5rem;
            row-gap: 3rem;
        }
    `}
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
        grid-column-start: span 12;

        @media ${theme.breakpoints.medium.media} {
            grid-column: span 4;
        }

        @media ${theme.breakpoints.large.media} {
            grid-column: span 3;
        }
    `}
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0;
`;

export const LoadMoreButton = styled(Button)`
    ${({ theme }) => css`
        width: 100%;
        justify-content: center;
        z-index: 2;

        :hover {
            border-radius: 2rem;
        }

        @media ${theme.breakpoints.medium.media} {
            width: auto;
        }
    `}
`;

export const FiltersList = styled.ul`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            list-style: none;
            background-color: ${theme.colors.secondary.hex};
            display: flex;
            flex-wrap: wrap;
            gap: 2rem;
            row-gap: 0.5rem;
            justify-content: center;
            padding: 1rem;
            border-radius: 0.5rem;
        }
    `}
`;

export const StyledButton = styled.button<{ $active: boolean }>`
    ${({ theme, $active }) => css`
        color: ${theme.colors.text.hex};
        border: none;
        background: none;
        text-decoration: none;

        :hover {
            color: ${theme.colors.primary.hex};
            text-decoration: underline;
            cursor: pointer;
        }

        ${$active &&
        css`
            color: ${theme.colors.primary.hex};
            text-decoration: underline;
        `}
    `}
`;

export const MiniFilterWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        width: 100%;
        background: ${theme.colors.secondary.hex};
        border-radius: 0.5rem;
        padding: 1rem;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            background: none;
            justify-content: end;
            align-items: center;
            gap: 1.5rem;
            padding: 0;
        }

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const StyledSelect = styled(Select)`
    ${({ theme }) => css`
        @media ${theme.breakpoints.medium.media} {
            min-width: 14.25rem;
        }
    `}
`;
